var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImageLayout',[_c('ContactMessage',{attrs:{"heading":"Change Password Error"}},[_c('strong',[_vm._v(_vm._s(_vm.errorMessage))]),_c('br')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }